// Copyright (c) Facebook, Inc. and its affiliates.
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { withStyles } from '@material-ui/core';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import * as images from '../image_list.json'

const styles = theme => ({
    gridContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      height: '350',
    },
    titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
});

class ImageList extends Component {

    getGridListCols = () => {
        if (isWidthDown('xs', this.props.width)) {
            return 4;
        } else if (isWidthDown('md', this.props.width)) {
            return 12;
        };
        return 24;
    };

    render() {
        const { classes } = this.props;
        let tileData = images.images;
        return (
          <div className={classes.gridContainer}>
            <GridList cellHeight={350} className={classes.gridList} cols={this.getGridListCols()}>
              {tileData.map(tile => (
                <GridListTile key={tile.img} cols={tile.cols || 1}>
                  <img src={tile.img} alt={tile.title} />
                  <GridListTileBar
                      title={tile.title}
                      titlePosition="top"
                      actionPosition="left"
                      className={classes.titleBar}
                  />
                </GridListTile>
              ))}
            </GridList>
          </div>
        );
    }
}

export default withWidth()(withStyles(styles)(ImageList));
